import type { Eye, Skeleton } from '@/modules/Editor/AnnotationData'

export const restoreJoints = <T extends Skeleton | Eye>(data: T): T['nodes'] =>
  data.nodes.map((node) => ({ ...node, occluded: false }))
